import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CustomBetModal from '../modals/CustomBetModal';
import CustomBetSearchModal from '../modals/CustomBetSearchModal';
import JudgeCustomBetModal from '../modals/JudgeCustomBetModal';
import MyCustomBets from '../layoutComponents/MyCustomBets';
import MyCustomBetStaging from '../layoutComponents/MyCustomBetStaging';

@observer(["ViewStore"])
class CustomBets extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };


    }

    async componentWillMount() {
        this.props.ViewStore.changeView('Custom Bets');
        this.props.ViewStore.changeCurrentPage('CustomBets')
    }

    componentWillUnmount(){
        this.props.ViewStore.changePreviousPage('CustomBets')
    }

    render() {

        return (
            <div className="custom-bets">
                <div className="new-custom-bet-btn">
              
                <CustomBetModal />
                <CustomBetSearchModal  />               
                </div>
                  <MyCustomBets />
                {/*<MyCustomBetStaging />*/}
            </div>
        );
    }
}

export default inject('store')(observer(CustomBets));


// WEBPACK FOOTER //
// ./src/components/appComponents/CustomBets.js